module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-content"
  }, [_c('p', [_vm._v("O cadastro na Área Administrativa é realizada por um(a) Administrador(a) do Sistema.")]), _c('p', [_vm._v("Caso você não possua acesso, solicite a um(a).")]), _c('hr'), _c('p', [_vm._v("Essa Área Administrativa é restirta e apenas os usuários cadastrados podem acessar os seus recursos.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-651261e0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/auth/components/HelpModal.vue
// module id = 402
// module chunks = 56